import { DataTable } from "primereact/datatable";
import { ISearchedResumes } from "./Table";
import { Column } from "primereact/column";
import { useEffect, useRef, useState } from "react";
import { JVInput } from "../../shared/JVInput";
import { useForm } from "react-hook-form";
import { Button } from "primereact/button";
import { Fetch } from "../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

interface IProps {
    toast?: any,
    data?: ISearchedResumes,
    open?: boolean
}

const schema = yup.object({
    comments: yup.string().required("Comments is required"),
});

export const Note = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const dt = useRef<any>(null);

    const { control, handleSubmit, formState: { errors }, reset } = useForm<{ comments: string }>({
        resolver: yupResolver(schema),
        defaultValues: { comments: "" },
        shouldFocusError: false
    });

    const header = () => {
        return (
            <>
            </>
        );
    }

    const saveComment = async (data: any) => {
        setLoading(true);
        const response = await Fetch("FindResume/addComment", "POST", data, null, props.toast);
        if (response) {
            const data = await response.json();
            props.toast.current.show({ severity: 'success', detail: `${data.resp} Successfully`, life: 3000 });
            reset({ comments: "" });
            setLoading(false);
        } else setLoading(false);
    }

    const onSubmit = (data: { comments: string }) => {
        let newComment: any = {
            comments: data.comments,
            consultant_ID: props.data?.consultant_ID
        };
        saveComment(newComment);
    }

    useEffect(() => {
        if (props.open) setTableData({ tableData: [props.data], loading: false });
        else setTableData({ tableData: [], loading: false });
    }, [props.open]);

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small"
                value={tableData.tableData} lazy dataKey="id"
                emptyMessage="No Pages found."
                header={header}
                loading={tableData.loading}
            >
                <Column field="consultant_ID" header="Consultant ID" />
                <Column field="consultant_Name" header="Consultant Name" />
                <Column field="consultant_Job_Title" header="Job Title" />
                <Column field="status" header="Status" />
            </DataTable>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-5" >
                <JVInput required column={1} label="Add your Comments" control={control} name="comments" error={errors.comments?.message} />
                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6" label="SAVE" loading={loading} disabled={loading} type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => { reset({ comments: "" }); }} type="button"></Button>
                </div>
            </form>
        </>
    );
}